import { GLYPH_PATTERN } from '../data/products';
import styles from './Glyph.module.css';

export default function Glyph({ className }) {
  return (
    <div className={`${styles.glyph} ${className || ''}`}>
      {GLYPH_PATTERN.map((val, i) => (
        <div
          key={i}
          className={val ? `${styles.cell} ${styles.active}` : styles.cell}
        />
      ))}
    </div>
  );
}
